module.exports = __webpack_public_path__ + "static/media/tree.7b9e5868.png";